export default {"src":"/_next/static/media/questions.73de1928.svg","height":223,"width":399};